import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const categoryLinks = categories.slice(0, 7);
  const moreLinks = categories.slice(7);

  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-sm">
                P
              </div>
              <span className="font-heading text-lg font-semibold text-white whitespace-nowrap">
                Pandabuy Sheet
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              The curated Pandabuy Spreadsheet directory — discover trending fashion finds, trusted sellers, and smart shopping resources updated daily.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-white mb-4 whitespace-nowrap">Categories</h4>
            <ul className="space-y-2.5">
              {categoryLinks.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-white mb-4 whitespace-nowrap">More Categories</h4>
            <ul className="space-y-2.5">
              {moreLinks.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-white mb-4 whitespace-nowrap">SEO Guides</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/pandabuy-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/pandabuy-spreadsheet-for-beginners" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Beginners Guide
                </Link>
              </li>
              <li>
                <Link to="/pandabuy-spreadsheet-sneakers" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Sneakers Guide
                </Link>
              </li>
              <li>
                <Link to="/budget-pandabuy-finds-under-50" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Budget Finds
                </Link>
              </li>
              <li>
                <Link to="/pandabuy-spreadsheet-luxury-brands" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Luxury Brands
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-white mb-4 whitespace-nowrap">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/summer-pandabuy-fashion-finds" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Summer Finds
                </Link>
              </li>
              <li>
                <Link to="/winter-pandabuy-spreadsheet-collection" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Winter Collection
                </Link>
              </li>
              <li>
                <Link to="/best-pandabuy-hoodies-collection" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Hoodies Guide
                </Link>
              </li>
              <li>
                <Link to="/pandabuy-accessories-guide" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Accessories Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Main Site
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Pandabuy Sheet. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
            >
              Privacy
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
            >
              Disclaimer
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}